// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cell-hover-planner {
  background-color: #f3f5f9;
}

.top-border-past {
  border-top: 1px solid var(--color-grey-91);
  border-top: 1px solid var(--color-grey-91);
}

.top-border-future {
  border-top: 1px solid var(--color-grey-96);
  border-top: 1px solid var(--color-grey-96);
}

.left-border-planner {
  border-left: 1px solid var(--color-grey-96);
  border-left: 1px solid var(--color-grey-96);
}

.right-border-grey91 {
  border-right: 1px solid var(--color-grey-91);
  border-right: 1px solid var(--color-grey-91);
}

.season-boundary-planner {
  border-left: 2px solid var(--color-grey-71);
  border-left: 2px solid var(--color-grey-71);
}

.planner-item-title {
  -webkit-line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  line-height: 15px;
}

.right-border-icon {
  border-right: 1px solid var(--color-grey-80);
  border-right: 1px solid var(--color-grey-80);
}

.tab-active {
  display: flex;
  justify-content: space-between;
  font-weight: bold;
  text-transform: uppercase;
  cursor: pointer;
}

.tab-inactive {
  display: flex;
  justify-content: space-between;
  font-weight: bold;
  text-transform: uppercase;
  cursor: pointer;
}

.tab-inactive .tab-text-inactive {
  color: var(--color-grey-71);
  color: var(--color-grey-71);
  font-weight: bold;
  text-transform: uppercase;
}

.tab-inactive:hover .tab-text-inactive {
  color: var(--color-grey-45);
  color: var(--color-grey-45);
}

.tab-inactive:active .tab-text-inactive {
  color: var(--color-grey-34);
  color: var(--color-grey-34);
}

.tab-text-active {
  color: var(--color-primary-idel);
  color: var(--color-primary-idel);
}

.tab-active:hover .tab-text-active {
  color: var(--color-primary-hover);
  color: var(--color-primary-hover);
}

.tab-active:active .tab-text-active {
  color: var(--color-primary-on-press);
  color: var(--color-primary-on-press);
}

.tab-bar-active {
  background-color: var(--color-primary-idel);
  background-color: var(--color-primary-idel);
}

.tab-active:hover .tab-bar-active {
  background-color: var(--color-primary-hover);
  background-color: var(--color-primary-hover);
}

.tab-active:active .tab-bar-active {
  background-color: var(--color-primary-on-press);
  background-color: var(--color-primary-on-press);
}

.list-item {
  background-color: white;
}

.list-item:hover {
  background-color: var(--color-grey-96);
  background-color: var(--color-grey-96);
}

.tab-bar-inactive {
  background-color: transparent;
}

.summary-col {
  height: 32px;
  display: grid;
}

.note-cell--past {
  background-color: var(--color-grey-99);
  background-color: var(--color-grey-99);
}

.note-cell--future {
  background-color: var(--color-grey-100);
  background-color: var(--color-grey-100);
}

.note-cell--past:hover {
  background-color: var(--color-grey-96);
  background-color: var(--color-grey-96);
}

.note-cell--future:hover {
  background-color: #f3f5f9;
}

.note-cell-content--border:hover {
  background-color: var(--color-grey-91);
  background-color: var(--color-grey-91);
  border: 1px solid var(--color-grey-80);
  border: 1px solid var(--color-grey-80);
}

.note-cell-content--no-border:hover {
  background-color: var(--color-grey-91);
  background-color: var(--color-grey-91);
}

.text-button {
}

.text-button:hover {
  background-color: var(--color-grey-96);
  background-color: var(--color-grey-96);
  border-radius: 3px;
}

.text-button:active {
  background-color: var(--color-grey-91);
  background-color: var(--color-grey-91);
  border-radius: 3px;
}

.export-popup {
  position: fixed;
  top: 95px;
  right: 16px;
  border: 1px solid var(--color-grey-91);
  border: 1px solid var(--color-grey-91);
  background-color: white;
  border-radius: 10px;
  width: 320px;
  height: 172px;
  padding: 24px;
}
`, "",{"version":3,"sources":["webpack://./app/components/planning/planner.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;EAA1C,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;EAA1C,0CAA0C;AAC5C;;AAEA;EACE,2CAA2C;EAA3C,2CAA2C;AAC7C;;AAEA;EACE,4CAA4C;EAA5C,4CAA4C;AAC9C;;AAEA;EACE,2CAA2C;EAA3C,2CAA2C;AAC7C;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,4CAA4C;EAA5C,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAA3B,2BAA2B;EAC3B,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAA3B,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAA3B,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAAhC,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;EAAjC,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;EAApC,oCAAoC;AACtC;;AAEA;EACE,2CAA2C;EAA3C,2CAA2C;AAC7C;;AAEA;EACE,4CAA4C;EAA5C,4CAA4C;AAC9C;;AAEA;EACE,+CAA+C;EAA/C,+CAA+C;AACjD;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sCAAsC;EAAtC,sCAAsC;AACxC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,sCAAsC;EAAtC,sCAAsC;AACxC;;AAEA;EACE,uCAAuC;EAAvC,uCAAuC;AACzC;;AAEA;EACE,sCAAsC;EAAtC,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EAAtC,sCAAsC;EACtC,sCAAsC;EAAtC,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;EAAtC,sCAAsC;AACxC;;AAEA;AACA;;AAEA;EACE,sCAAsC;EAAtC,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;EAAtC,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,sCAAsC;EAAtC,sCAAsC;EACtC,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,aAAa;AACf","sourcesContent":[".cell-hover-planner {\n  background-color: #f3f5f9;\n}\n\n.top-border-past {\n  border-top: 1px solid var(--color-grey-91);\n}\n\n.top-border-future {\n  border-top: 1px solid var(--color-grey-96);\n}\n\n.left-border-planner {\n  border-left: 1px solid var(--color-grey-96);\n}\n\n.right-border-grey91 {\n  border-right: 1px solid var(--color-grey-91);\n}\n\n.season-boundary-planner {\n  border-left: 2px solid var(--color-grey-71);\n}\n\n.planner-item-title {\n  -webkit-line-clamp: 2;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  line-height: 15px;\n}\n\n.right-border-icon {\n  border-right: 1px solid var(--color-grey-80);\n}\n\n.tab-active {\n  display: flex;\n  justify-content: space-between;\n  font-weight: bold;\n  text-transform: uppercase;\n  cursor: pointer;\n}\n\n.tab-inactive {\n  display: flex;\n  justify-content: space-between;\n  font-weight: bold;\n  text-transform: uppercase;\n  cursor: pointer;\n}\n\n.tab-inactive .tab-text-inactive {\n  color: var(--color-grey-71);\n  font-weight: bold;\n  text-transform: uppercase;\n}\n\n.tab-inactive:hover .tab-text-inactive {\n  color: var(--color-grey-45);\n}\n\n.tab-inactive:active .tab-text-inactive {\n  color: var(--color-grey-34);\n}\n\n.tab-text-active {\n  color: var(--color-primary-idel);\n}\n\n.tab-active:hover .tab-text-active {\n  color: var(--color-primary-hover);\n}\n\n.tab-active:active .tab-text-active {\n  color: var(--color-primary-on-press);\n}\n\n.tab-bar-active {\n  background-color: var(--color-primary-idel);\n}\n\n.tab-active:hover .tab-bar-active {\n  background-color: var(--color-primary-hover);\n}\n\n.tab-active:active .tab-bar-active {\n  background-color: var(--color-primary-on-press);\n}\n\n.list-item {\n  background-color: white;\n}\n\n.list-item:hover {\n  background-color: var(--color-grey-96);\n}\n\n.tab-bar-inactive {\n  background-color: transparent;\n}\n\n.summary-col {\n  height: 32px;\n  display: grid;\n}\n\n.note-cell--past {\n  background-color: var(--color-grey-99);\n}\n\n.note-cell--future {\n  background-color: var(--color-grey-100);\n}\n\n.note-cell--past:hover {\n  background-color: var(--color-grey-96);\n}\n\n.note-cell--future:hover {\n  background-color: #f3f5f9;\n}\n\n.note-cell-content--border:hover {\n  background-color: var(--color-grey-91);\n  border: 1px solid var(--color-grey-80);\n}\n\n.note-cell-content--no-border:hover {\n  background-color: var(--color-grey-91);\n}\n\n.text-button {\n}\n\n.text-button:hover {\n  background-color: var(--color-grey-96);\n  border-radius: 3px;\n}\n\n.text-button:active {\n  background-color: var(--color-grey-91);\n  border-radius: 3px;\n}\n\n.export-popup {\n  position: fixed;\n  top: 95px;\n  right: 16px;\n  border: 1px solid var(--color-grey-91);\n  background-color: white;\n  border-radius: 10px;\n  width: 320px;\n  height: 172px;\n  padding: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
